import { render, staticRenderFns } from "./ConnectCard.vue?vue&type=template&id=59f3ad7a&scoped=true&"
import script from "./ConnectCard.vue?vue&type=script&lang=js&"
export * from "./ConnectCard.vue?vue&type=script&lang=js&"
import style0 from "./ConnectCard.vue?vue&type=style&index=0&id=59f3ad7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f3ad7a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
